import { render, staticRenderFns } from "./automaticPrice.vue?vue&type=template&id=628890e3&scoped=true&"
import script from "./automaticPrice.vue?vue&type=script&lang=js&"
export * from "./automaticPrice.vue?vue&type=script&lang=js&"
import style0 from "./automaticPrice.vue?vue&type=style&index=0&id=628890e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628890e3",
  null
  
)

export default component.exports